import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
import NotFound from "@/pages/NotFoundPage.vue";

let server = [
  {
    path: "dashboard",
    name: "Главная",
    component: () => import("@/pages/Dashboard.vue"),
  },
  {
    path: "dashboard-bss",
    name: "Главная",
    component: () => import("@/pages/DashboardBSS.vue"),
  },
  {
    path: "orders",
    name: "Заказы",
    component: () => import("@/pages/Orders.vue"),
  },
  {
    path: "variants",
    name: "Склад",
    component: () => import("@/pages/Stock.vue"),
  },
  {
    path: "transactions",
    name: "Выгрузки",
    component: () => import("@/pages/Transactions.vue"),
  },
  {
    path: "systems",
    name: "Системы",
    component: () => import("@/pages/Systems.vue"),
  },
  {
    path: "system_keys",
    name: "Системные связи",
    component: () => import("@/pages/SystemKeys.vue"),
  },
  {
    path: "organizations",
    name: "Организации",
    component: () => import("@/pages/Organizations.vue"),
  },
  {
    path: "certified_checks",
    name: "Активированные чеки",
    component: () => import("@/pages/CertifiedChecks.vue"),
  },
  {
    path: "banks",
    name: "Банки",
    component: () => import("@/pages/Banks.vue"),
  },
  {
    path: "loans",
    name: "Заявки в банк",
    component: () => import("@/pages/Loans.vue"),
  },
  {
    path: "tickets",
    name: "Тикеты",
    component: () => import("@/pages/Tickets.vue"),
  },
  {
    path: "certificates",
    name: "Сертификаты",
    component: () => import("@/pages/Certificates.vue"),
  },
  {
    path: "partner/orders",
    name: "Заказы партнера",
    component: () => import("@/pages/PartnerOrders.vue"),
  },
  {
    path: "payments",
    name: "Оплаты",
    component: () => import("@/pages/Payments.vue"),
  },
  {
    path: "trade_ins",
    name: "TRADE-IN",
    component: () => import("@/pages/TradeIns.vue"),
  },
  {
    path: "report_trade_ins",
    name: "TRADE-IN отчеты",
    component: () => import("@/pages/ReportTradeIns.vue"),
  },
  {
    path: "scan_trade_ins",
    name: "Движение товаров TRADE-IN",
    component: () => import("@/pages/ScanTradeIns.vue"),
  },
  {
    path: "insurance_orders",
    name: "Страховка",
    component: () => import("@/pages/InsuranceOrders.vue"),
  },
  {
    path: "log_orders",
    name: "Логи заказов",
    component: () => import("@/pages/LogOrders.vue"),
  },
  {
    path: "services",
    name: "Сервисы",
    component: () => import("@/pages/Services.vue"),
  },
  {
    path: "infos",
    name: "Инфо-блоки",
    component: () => import("@/pages/Infos.vue"),
  },
  {
    path: "ticket_rubrics",
    name: "Категории тикетов",
    component: () => import("@/pages/TicketRubrics.vue"),
  },
  {
    path: "logs",
    name: "Логги",
    component: () => import("@/pages/Logs.vue"),
  },
  {
    path: "shops",
    name: "Заказы",
    component: () => import("@/pages/Shops.vue"),
  },
  {
    path: "info_projects",
    name: "Инфо проектов",
    component: () => import("@/pages/InfoProjects.vue"),
  },
  {
    path: "partners",
    name: "Партнеры",
    component: () => import("@/pages/Partners.vue"),
  },
  {
    path: "clients",
    name: "Клиенты",
    component: () => import("@/pages/Clients.vue"),
  },
  {
    path: "roles",
    name: "Роли",
    component: () => import("@/pages/Roles.vue"),
  },
  {
    path: "prices",
    name: "Цены на товары",
    component: () => import("@/pages/Prices.vue"),
  },
  {
    path: "dealers",
    name: "Компании",
    component: () => import("@/pages/Dealers.vue"),
  },
  {
    path: "words",
    name: "Слова",
    component: () => import("@/pages/Words.vue"),
  },
  {
    path: "sections",
    name: "Экраны",
    component: () => import("@/pages/Sections.vue"),
  },
  {
    path: "users",
    name: "Пользователи",
    component: () => import("@/pages/Users.vue"),
  },
  {
    path: "statuses",
    name: "Статусы заказов",
    component: () => import("@/pages/Statuses.vue"),
  },
  {
    path: "imports",
    name: "Импорт данных",
    component: () => import("@/pages/Imports.vue"),
  },
  {
    path: "transfers",
    name: "TRADE-IN (Перемещение)",
    component: () => import("@/pages/Transfers.vue"),
  },

  {
    path: "register",
    name: "Реестр",
    component: () => import("@/pages/Register.vue"),
  },
  {
    path: "report/scorings",
    name: "Скоринги",
    component: () => import("@/pages/ReportScorings.vue"),
  },
  {
    path: "report/paymart",
    name: "Paymart LOGS",
    component: () => import("@/pages/ReportPaymart.vue"),
  },
  {
    path: "report/subscriptions",
    name: "Отчет",
    component: () => import("@/pages/ReportSubscriptions.vue"),
  },
  {
    path: "registry_reports",
    name: "Отчет",
    component: () => import("@/pages/RegistryReports.vue"),
  },
  {
    path: "registry_templates",
    name: "Шаблоны",
    component: () => import("@/pages/RegistryTemplates.vue"),
  },
  {
    path: "test",
    name: "Скоринг тест",
    component: () => import("@/pages/Test.vue"),
  },
  {
    path: "report/scorings/week",
    name: "Скоринги",
    component: () => import("@/pages/ReportScoringWeeks.vue"),
  },
  {
    path: "promotions",
    name: "Акции",
    component: () => import("@/pages/Promotions.vue"),
  },
  {
    path: "reports",
    name: "Отчеты",
    component: () => import("@/pages/Reports.vue"),
  },
  {
    path: "system_functions",
    name: "Системные функции",
    component: () => import("@/pages/SystemFunctions.vue"),
  },
  {
    path: "quit",
    name: "Выход",
    component: () => import("@/pages/Quit.vue"),
  },
  {
    path: "trade-in",
    name: "Трейд Ин",
    component: () => import("@/pages/TradeIn.vue"),
  },
  {
    path: "personal/dealers",
    name: "Трейд Ин",
    component: () => import("@/pages/PersonalDealers.vue"),
  },
  {
    path: "subscriptions",
    name: "Смартфон по подписке",
    component: () => import("@/pages/Subscriptions.vue"),
  },
  {
    path: "tariffs",
    name: "Тарифы сервисов",
    component: () => import("@/pages/Tariffs.vue"),
  },
  {
    path: "imeis",
    name: "ИМЕИ",
    component: () => import("@/pages/Imeis.vue"),
  },
  {
    path: "alif-orders",
    name: "Заказ ALIF",
    component: () => import("@/pages/AlifOrders.vue"),
  },
];

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    children: server,
  },
  { path: "*", component: NotFound },
];

export default routes;
